<template>
  <!-- 递归分类节点：children 存在则是分组（组名 + CSS 图标，整行点击展开/收起），否则为叶子（checkbox 可勾选） -->
  <div>
    <template v-if="node">
      <template v-if="isGroup">
        <!-- 分组节点：左侧组名居左，右侧 CSS 图标（+ 收起 / − 展开），整行点击切换 -->
        <li
          :class="['cat-node', 'cat-group', 'level-' + level]"
          @click.stop="toggleGroup"
        >
          <span class="cat-name">{{ node.name }}</span>
          <i :class="['cat-icon', node._collapse ? 'icon-plus' : 'icon-minus']" />
        </li>
        <!-- 展开时递归渲染子节点（ternary 避免 v-if 与 v-for 同标签共存） -->
        <category-node
          v-for="(child, i) in (node._collapse ? [] : node.children)"
          :key="i"
          :class="{'cat-last': i === node.children.length - 1}"
          :node="child"
          :level="level + 1"
          :checked="checked"
          @toggle="$emit('toggle', $event)"
          @pick="$emit('pick', $event)"
        />
      </template>
      <!-- 叶子节点：checkbox + 名称 -->
      <li v-else :class="['cat-node', 'cat-leaf', 'level-' + level]" @click.stop="$emit('pick', node.id)">
        <i class="iconfont">{{isChecked ? '&#xedaf;' : '&#xec58;'}}</i>
        <a>{{ node.name }}</a>
      </li>
    </template>
  </div>
</template>

<script>
export default {
  name: 'CategoryNode',
  props: {
    node: Object,
    level: {
      type: Number,
      default: 0
    },
    checked: {
      type: Array,
      default: () => []
    }
  },
  computed: {
    // 有 children 就是分组（无 checkbox），其余为叶子（有 checkbox）
    isGroup() {
      return !!(this.node && this.node.children && this.node.children.length);
    },
    isChecked() {
      return this.checked.indexOf(String(this.node.id)) != -1;
    }
  },
  methods: {
    // 整行点击切换展开/收起
    toggleGroup() {
      this.$emit('toggle', this.node);
    }
  }
};
</script>

<style lang="scss" scoped>
  // 每组最后一个子项：类名经 fallthrough 落在子组件根元素上，
  // margin 作用于该子树整体之外（末项为展开的子分组时间距也在其全部内容之后）
  .cat-last {
    margin-bottom: 25px;
  }
  .cat-node {
    display: flex;
    align-items: center;
    gap: 10px;
    padding: 4px 0;
    line-height: 22px;
    font-size: 13px;
    cursor: pointer;
    text-align: left;
    a {
      font-size: 13px;
      color: #333;
      text-decoration: none;
    }
    &.cat-group {
      color: #000;
      font-weight: 700;
      .cat-name {
        flex: 1;
        padding: 0;
      }
      // 纯 CSS 绘制的展开/收起图标（与外层筛选保持一致的 +/- 视觉）
      .cat-icon {
        display: inline-block;
        width: 14px;
        height: 14px;
        position: relative;
        flex-shrink: 0;
        // 横线（两种状态都有）
        &::before {
          content: '';
          position: absolute;
          top: 50%;
          left: 0;
          right: 0;
          height: 2px;
          background: #333;
          transform: translateY(-50%);
          border-radius: 1px;
        }
        // 竖线（只在 + 状态显示）
        &::after {
          content: '';
          position: absolute;
          left: 50%;
          top: 0;
          bottom: 0;
          width: 2px;
          background: #333;
          transform: translateX(-50%);
          border-radius: 1px;
        }
        // − 状态：隐藏竖线
        &.icon-minus::after {
          content: none;
        }
      }
    }
    &.cat-leaf {
      color: #333;
      font-weight: 400;
    }
    // 分组节点：level-0/1/2/3 缩进 0/12/24/36px
    &.level-0.cat-group { padding-left: 0; }
    &.level-1.cat-group { padding-left: 12px; }
    &.level-2.cat-group { padding-left: 24px; }
    &.level-3.cat-group { padding-left: 36px; }
    // 叶子节点在分组基础上再往里缩 14px（让 checkbox 视觉更靠里）
    // &.level-0.cat-leaf { padding-left: 26px; }
    &.level-1.cat-leaf { padding-left: 12px; }
    &.level-2.cat-leaf { padding-left: 24px; }
    &.level-3.cat-leaf { padding-left: 36px; }
    // &.level-4.cat-leaf { padding-left: 70px; }
  }
</style>
